import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-employee-statuses-filter',
  templateUrl: './employee-statuses-filter.component.html',
  styleUrls: ['./employee-statuses-filter.component.scss'],
  standalone: false,
})
export class EmployeeStatusesFilterComponent implements OnInit {
  @Input() filter;

  constructor() {}

  ngOnInit() {}

  onSearchUsers() {}

  onResetName() {}
}
